import { render } from "./quiz-v1-self-assessment-results.vue?vue&type=template&id=7f9d4ecf&scoped=true"
import script from "./quiz-v1-self-assessment-results.vue?vue&type=script&lang=js"
export * from "./quiz-v1-self-assessment-results.vue?vue&type=script&lang=js"

import "./quiz-v1-self-assessment-results.vue?vue&type=style&index=0&id=7f9d4ecf&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9d4ecf"]])

export default __exports__